export default __webpack_public_path__ + "static/media/object.62b1ff06.png";